import React, { useEffect, useState } from "react";
// importing the css
import css from "../../style/booking.module.css";
import { BiPlusMedical } from "react-icons/bi";
import { FaMinus } from "react-icons/fa";
import { CustomTooltip } from "../Tooltip/tooltip";
import CounterPopUp from "./CounterPopUp";

const FloorTooltip = () => {
  return (
    <div className={css?.tooltipMainDiv}>
      <div className={css?.tooltipBullet}>

        <div style={{ width: "calc(100% - 20px)" }}>
          <div className={css?.tooltipSectionHeading}>
            <span className={css?.tooltipDotSmall}></span>Elevator
          </div>
          <div className={css?.tooltipBody}>
            Elevator access can affect move time and price — enter your floor
            accurately (0 = main floor). Book the elevator with building
            management ahead of time.
          </div>

          <div className={css?.tooltipSectionHeading} style={{ marginTop: 12 }}>
            <span className={css?.tooltipDotSmall}></span>Stairs
          </div>
          <div className={css?.tooltipBody}>
            Stairs add time — enter your floor accurately (0 = main floor; 1 =
            one full flight up; 2 = two flights up, etc.). If there are more
            than 5 entry steps, count that as 1 floor.
          </div>

          <div className={css?.tooltipSectionHeading} style={{ marginTop: 12 }}>
            <span className={css?.tooltipDotSmall}></span>Main Floor
          </div>
          <div className={css?.tooltipBody}>
            Choose this if everything is on ground level (no elevator or full
            flights of stairs). If there are more than 5 entry steps, count that
            as 1 floor.
          </div>

          <div
            className={css?.tooltipBody}
            style={{ marginTop: 12, fontStyle: "italic" }}
          >
            At the “Contact info” step, share extra details like access codes,
            key fobs, steep access, or a long walk from parking.
          </div>
        </div>
      </div>
    </div>
  );
};

const Counter = ({
  value,
  label,
  type,
  min,
  max,
  increment,
  decrement,
  increment2,
  onValueChange,
}) => {
  const [isFocused, setIsFocused] = useState(false);
  const [showPopup, setShowPopup] = useState(false);
  const [inputValue, setInputValue] = useState(String(value ?? min ?? 1));

  useEffect(() => {
    setInputValue(String(value ?? min ?? 1));
  }, [value, min]);

  const clampValue = (num) => {
    if (Number.isNaN(num)) return min;
    return Math.min(max, Math.max(min, num));
  };

  const commitInputValue = (rawValue) => {
    if (onValueChange === undefined) {
      setInputValue(String(value ?? min ?? 1));
      return;
    }

    const parsed = parseInt(rawValue, 10);
    const finalValue = clampValue(parsed);
    onValueChange(finalValue);
    setInputValue(String(finalValue));
  };

  const handleDecrementClick = () => {
    if (value === min) {
      setShowPopup(true);
      return;
    }

    if (value > min) decrement();
  };
  return (
    <>
      <div className={css?.counterMainDiv} style={{ marginTop: 0 }}>
        <div
          className={css?.counterLabel}
          style={{
            marginTop:
              label && label.toString().includes("Floor number")
                ? "15px"
                : undefined,
          }}
        >
          <CustomTooltip title={<FloorTooltip />}>
            <span
              style={{
                display: "inline-flex",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              {label ?? "# of movers "}
              <img
                src="/images/tooltip.svg"
                style={{
                  width: 16,
                  height: 16,
                  marginLeft: 4,
                }}
                alt=""
              />
            </span>
          </CustomTooltip>
        </div>
        <div className={css?.counterStrip}>
          <div
            className={css?.counterBox}
            style={{
              border: isFocused ? "1px solid #7876A1" : "1px solid transparent",
            }}
          >
            <input
              type="text"
              inputMode="numeric"
              pattern="[0-9]*"
              value={inputValue}
              min={min}
              max={max}
              className={css?.counterInput}
              onChange={(e) => {
                const next = e.target.value;
                if (!/^\d*$/.test(next)) return;

                setInputValue(next);
                if (next === "") return;
                commitInputValue(next);
              }}
              onFocus={() => setIsFocused(true)}
              onBlur={() => {
                setIsFocused(false);
                if (inputValue === "") {
                  commitInputValue(String(min));
                  return;
                }
                commitInputValue(inputValue);
              }}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.currentTarget.blur();
                }
              }}
              style={{
                outline: "none",
                height: 36,
                border: "none",
                backgroundColor: "transparent",
                boxSizing: "border-box",
              }}
            />

            {value > min ? (
              <div
                onClick={handleDecrementClick}
                className={css?.counterButtons}
              >
                <FaMinus />
              </div>
            ) : (
              <div
                onClick={handleDecrementClick}
                className={css?.counterButtons}
                style={{ backgroundColor: "#9e9ac7" }}
              >
                <FaMinus />
              </div>
            )}

            {value < max ? (
              <div className={css?.counterButtons} onClick={() => increment()}>
                <BiPlusMedical />
              </div>
            ) : (
              <div
                className={css?.counterButtons}
                style={{ backgroundColor: "#9e9ac7" }}
                onClick={() => value < max && increment()}
              >
                <BiPlusMedical />
              </div>
            )}
          </div>
        </div>
      </div>
      <CounterPopUp isOpen={showPopup} onClose={() => setShowPopup(false)} />
    </>
  );
};

export default Counter;
